import BaseEntity from '@/entity/BaseEntity';
import { getWeekDatesFromWeekNumber } from '@/utils/tools';

export default class TimeTicketListItemEntity<T extends Armado.TimeTicketWeekYear = Armado.TimeTicketWeekYear> extends BaseEntity<T> {

	get weekNumber () { return this.state.weekNumber;}
	get qtyPending () { return this.state.qtyPending;}
	get qtyToValidate () { return this.state.qtyToValidate;}
	get qtyValidated () { return this.state.qtyValidated;}
	get qtyIntegrated () { return this.state.qtyIntegrated;}
	get year () { return this.state.year;}

	get labelToFillClient () {
		return this.self.isAgency() ? 'À saisir par le client' : 'À saisir';
	}

	get readableDates () {
		const dates = getWeekDatesFromWeekNumber(this.state.weekNumber, this.state.year);
		return `Du ${dates.start.toReadable()} au  ${dates.end.toReadable()}`;
	}
}
